import { Box, Typography } from "@mui/material";
import { Component } from "react";
import moment from "moment";
import datalink from "./datalink";
import schema from "./schema";
import { HStack, VStack } from "Components";
import { Accessor, Authority, ColorX } from "static";
import Formizo from "Components/LabIZO/Formizo";
import { Spacer } from "Components/LabIZO/Stackizo";
import Datumizo from "Components/LabIZO/Datumizo";

type FrequentlyAskProps = typeof FrequentlyAsk.defaultProps;

interface FrequentlyAskStates {
  title: string;
  period: { DateRange: [string, string] };
  serverSidePagination: boolean;
  base: any;
  confidenceFrom: number;
  confidenceTo: number;
  formValue: {
    confidenceFrom: number;
    confidenceTo: number;
  };
}

class FrequentlyAsk extends Component<FrequentlyAskProps, FrequentlyAskStates> {
  static defaultProps = {};
  MountDatumizo: Record<string, (...args: any[]) => any> = {};

  constructor(props: FrequentlyAskProps) {
    super(props);
    this.state = {
      title: "Frequently Ask Report",
      period: { DateRange: [moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), moment().endOf("month").format("YYYY-MM-DD HH:mm:ss")] },
      serverSidePagination: true,
      base: {
        title: "FrequentlyAsk",
        exportDoc: "FrequentlyAsk",
        schema,
        reqAuth: "Report.FrequentlyAsk",

        tablizo: {
          showSelector: true,
          columnsToolbar: false,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
        },

        Connect: {
          List: datalink.Request.List,
          schema: schema.Table,
        },

        operations: {
          Export: {
            url: datalink.Request.Export,
            schema: schema.Export,
          },

          Info: {
            title: "AUDIT LOG DETAILS",
            url: datalink.Request.Info,
            success: "Audit Log Successfully",
            fail: "Audit Log Failed: ",
            schema: schema.Info,
            readOnly: true,
          },
        },

        buttons: {
          //inline: [{ icon: "info", func: "Info", reqFunc: "Info", caption: "Details" }],
          right: [{ icon: "export", func: "Export", caption: (n: number) => `Export (${n === 0 ? "All" : n})`, reqFunc: "Export" }],
        },
      },
      confidenceFrom: 0.7,
      confidenceTo: 1,
      formValue: {
        confidenceFrom: 0.7,
        confidenceTo: 1,
      },
    };
  }

  componentDidMount() {
    Authority.Require("Report.FrequentlyAsk");
    this._setAllStates();
  }

  componentDidUpdate(prevProps: FrequentlyAskProps, prevState: FrequentlyAskStates) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(FrequentlyAsk.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback?: () => void) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  onMountDatumizo = (callbacks: Record<string, (...args: any[]) => any>) => {
    this.MountDatumizo = callbacks;
  };

  renderDatePicker = () => {
    const { period } = this.state;
    return (
      <Formizo
        width={350}
        height="100%"
        schema={[
          {
            label: "",
            name: "DateRange",
            format: "daterange",
            dateType: "datetime",
            dateFormat: "YYYY-MM-DD HH:mm:ss",
            noLabelGrid: true,
            defaultValue: period.DateRange,
          },
        ]}
        buttons={[]}
        onChange={(value, _n, _v, fetchData) => {
          this.setState((state) => {
            const from = moment(value.DateRange[0]).format("YYYYMMDD");
            const to = moment(value.DateRange[1]).format("YYYYMMDD");
            return {
              period: value,
              base: {
                ...state.base,
                exportDoc: `FrequentlyAsk_${from}_${to}`,
              },
            };
          });
          if (fetchData) {
            this.MountDatumizo.Reload();
          }
        }}
      />
    );
  };

  renderConfidenceFilter = () => {
    return (
      <Formizo
        width={350}
        height="100%"
        schema={[
          {
            label: "Confidence From",
            name: "confidenceFrom",
            format: "number",
            defaultValue: this.state.confidenceFrom,
          },
          {
            label: "Confidence To",
            name: "confidenceTo",
            format: "number",
            defaultValue: this.state.confidenceTo,
          },
        ]}
        buttons={[]}
        onChange={(formValue, _n, _v, fetchData) => {
          if (formValue.confidenceFrom !== this.state.confidenceFrom || formValue.confidenceTo !== this.state.confidenceTo) {
            this.setState({
              confidenceFrom: formValue.confidenceFrom,
              confidenceTo: formValue.confidenceTo,
              formValue: formValue,
            });
            if (fetchData) {
              this.MountDatumizo.Reload();
            }
          }
        }}
      />
    );
  };

  renderTable = () => {
    let { base, serverSidePagination, period, confidenceFrom, confidenceTo } = this.state;
    return (
      <Datumizo
        base={base}
        addOns={{
          ...period,
          confidenceFrom,
          confidenceTo,
        }}
        serverSidePagination={serverSidePagination}
        onMounted={this.onMountDatumizo}
        languageSelector={false}
      />
    );
  };

  render = () => {
    const { title } = this.state;
    return (
      <VStack height="100%" width="100%">
        <Box padding={1} width="100%">
          <HStack
            justifyContent="space-between"
            style={{
              display: "flex",
              width: "100%",
            }}
          >
            <Typography
              style={{
                alignItems: "left",
                display: "flex",
                fontSize: 25,
                color: ColorX.GetColorCSS("Primary"),
              }}
            >
              {title}
            </Typography>
            {this.renderDatePicker()}
            <Spacer />
          </HStack>
          <Typography
            style={{
              alignItems: "left",
              display: "flex",
              fontSize: 5,
            }}
          >
            {this.renderConfidenceFilter()}
          </Typography>
        </Box>
        {this.renderTable()}
      </VStack>
    );
  };
}

export default FrequentlyAsk;
